import { axiosRequest, type AxiosResult } from "@/lib/axios";
import type { LoginRequest, SignupRequest, LoginResponse, ValidateOtpRequest } from "../types";
import type { User } from "@/modules/user/types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export const authApi = {
	login: (payload: LoginRequest): Promise<AxiosResult<LoginResponse>> => {
		return axiosRequest({ url: `${API_BASE_URL}/auth/login`, method: "POST", data: payload });
	},

	signup: (payload: SignupRequest): Promise<AxiosResult<LoginResponse>> => {
		return axiosRequest({ url: `${API_BASE_URL}/auth/signup`, method: "POST", data: payload });
	},

	logout: (): Promise<AxiosResult<void>> => {
		return axiosRequest({ url: `${API_BASE_URL}/auth/logout`, method: "POST" });
	},

	validateOtp: (payload: ValidateOtpRequest): Promise<AxiosResult<void>> => {
		// Check if code is already base64 encoded
		const isBase64Encoded = /^[A-Za-z0-9+/]+=*$/.test(payload.code) && payload.code.length % 4 === 0;

		let encodedCode = payload.code;

		if (!isBase64Encoded) {
			encodedCode = btoa(payload.code);
		}

		return axiosRequest({ url: `${API_BASE_URL}/auth/validate`, method: "POST", data: { session_id: payload.session_id, code: encodedCode } });
	},

	info: (): Promise<AxiosResult<User>> => {
		return axiosRequest({ url: `${API_BASE_URL}/auth/info`, method: "GET" });
	},

	verify: (): Promise<AxiosResult<void>> => {
		return axiosRequest({ url: `${API_BASE_URL}/auth/verify`, method: "GET" });
	},

	updateProfile: (payload: Partial<User>): Promise<AxiosResult<User>> => {
		return axiosRequest({ url: `${API_BASE_URL}/auth/self`, method: "PATCH", data: payload });
	},

	updateAvatar: (file: File): Promise<AxiosResult<User>> => {
		const formData = new FormData();
		formData.append("avatar", file);
		return axiosRequest({
			url: `${API_BASE_URL}/auth/self/avatar`,
			data: formData,
			method: "POST",
			headers: { "Content-Type": "multipart/form-data" },
		});
	},

	deleteAvatar: (): Promise<AxiosResult<User>> => {
		return axiosRequest({ url: `${API_BASE_URL}/auth/self/avatar`, method: "DELETE" });
	},
};
